export default __webpack_public_path__ + "static/media/dpr.4efd15d5.svg";